import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import TasksLists from "./TasksLists";
import TaskBoard from "./TaskBoard";
import AddTask from "./AddTask";
import { connect, useSelector } from "react-redux";
import MileStoneModal from "./MileStoneModal";
import Filter from "./Filters/Filter";
import TrashedTasks from "./Trash/Index";
import TaskStatus from "./Status/TaskStatus";
import { useDispatch } from "react-redux";
import { motion, AnimatePresence } from "motion/react";

const Tasks = ({ data }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("task");
  const [isAddTaskShown, setAddTaskIsShown] = useState(false);
  const [showTaskFilterMenu, setShowTaskFilterMenu] = useState(false);
  const [showTimeLogFilterData, setShowTimeLogFilterData] = useState(false);
  const [currentMilestone, setCurrentMilestone] = useState("");
  const [onRender, setOnRender] = useState(false);
  const [milestoneNames, setMilestoneNames] = useState([]);
  const [showMilestone, setShowMilestone] = useState([]);
  const [isButtonDisable, setIsButtonDisable] = useState(false);

  const permissionsData = useSelector((state) => state.permissions.permission);

  useEffect(() => {
    const fetchData = () => {
      if (!permissionsData) {
        setIsButtonDisable(false);
        return;
      }
      const permList = Array.isArray(permissionsData)
        ? permissionsData
        : permissionsData?.permissions || permissionsData?.data?.permissions;

      if (Array.isArray(permList) && permList.length > 0) {
        const handlePerm = permList.find(
          (item) => item.action === "Handle-Milestone-And-Tasks"
        );
        if (handlePerm && handlePerm.allowed === false) {
          setIsButtonDisable(true);
        } else {
          setIsButtonDisable(false);
        }
      } else {
        setIsButtonDisable(false);
      }
    };
    fetchData();
  }, [permissionsData]);

  const [filterMenu, setFilterMenu] = useState({
    milestone_id: [],
    milestone_name: [],
    assigned_to: [],
    assigned_to_name: [],
    task_status: [],
    is_task_finished: false,
    task_due_date: "",
  });
  const [timeFilterMenu, setTimeFilterMenu] = useState({
    user_id: "",
    user_name: [],
    start_date: "",
    end_date: "",
    is_bilable: "",
  });
  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [timeLogFilteredData, setTimeLogFilteredData] = useState([]);
  const filteredCount = useMemo(() => {
    //filter by status
    const groupedFields = [
      ["milestone_id", "milestone_name"],
      ["assigned_to", "assigned_to_name"],
      ["is_task_finished", "task_due_date"],
    ];

    let count = 0;

    groupedFields.forEach((group) => {
      if (
        group.some(
          (key) =>
            (filterMenu[key] !== "" && filterMenu[key].length > 0) ||
            filterMenu[key] === true
        )
      ) {
        count++;
      }
    });

    const individualFields = ["task_status"];

    individualFields.forEach((key) => {
      if (filterMenu[key].length > 0) {
        count++;
      }
    });

    //filter by time
    const groupFields = [
      ["user_id", "user_name"],
      ["start_date", "end_date"],
    ];
    groupFields.forEach((group) => {
      if (
        group.some(
          (key) =>
            (timeFilterMenu[key] !== "" && timeFilterMenu[key].length > 0) ||
            timeFilterMenu[key] === true
        )
      ) {
        count++;
      }
    });

    const singleFields = ["is_bilable"];

    singleFields.forEach((key) => {
      if (
        timeFilterMenu[key] == true ||
        (timeFilterMenu[key] == false && timeFilterMenu[key] !== "")
      ) {
        count++;
      }
    });

    return count;
  }, [filterMenu, timeFilterMenu]);
  const [isOption, setIsOption] = useState(false);
  const [isTrashOpen, setIsTrashOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const DetailedProjectDataFromStore = useSelector(
    (state) => state.projectDetails.getDetailedProjectData
  );

  const tasksListFromStore = useSelector((state) => {
    const list = state.projectDetails?.tasksList;
    return Array.isArray(list) ? list : list?.data;
  });

  const rawData =
    data?.project || data?.data?.project
      ? data
      : DetailedProjectDataFromStore;

  const projectData = rawData?.data?.project ? rawData.data : rawData;

  useEffect(() => {
    const projId = projectData?.project?._id;
    if (!projId) return;
    const fetchData = async () => {
      if (Array.isArray(tasksListFromStore) && tasksListFromStore.length > 0) {
        setTaskData(tasksListFromStore);
        return;
      }
      const res = await dispatch.projectDetails.getTasksList({
        project_id: projId,
      });
      setTaskData(res?.data);
    };
    fetchData();
  }, [projectData, tasksListFromStore]);

  const switchTaskView = () => {
    return (
      <div className="">
        {" "}
        {/* removed relative */}
        <AnimatePresence initial={false} mode="wait">
          {status === "task" && (
            <motion.div
              key="tasks"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 12 }}
              transition={{ duration: 0.28, ease: "easeOut" }}
            >
              <TasksLists
                data={projectData}
                onRender={onRender}
                setTaskData={setTaskData}
                isAddTaskShown={isAddTaskShown}
                setAddTaskIsShown={setAddTaskIsShown}
                showMilestone={showMilestone}
                setShowMilestone={setShowMilestone}
                milestoneNames={milestoneNames}
                setMilestoneNames={setMilestoneNames}
                timeLogFilteredData={timeLogFilteredData}
                showTimeLogFilterData={showTimeLogFilterData}
                currentMilestone={currentMilestone}
                setCurrentMilestone={setCurrentMilestone}
                isButtonDisable={isButtonDisable}
              />
            </motion.div>
          )}

          {status === "board" && (
            <motion.div
              key="board"
              initial={{ opacity: 0, y: -12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -12 }}
              transition={{ duration: 0.28, ease: "easeOut" }}
            >
              <TaskBoard
                data={projectData}
                mileStones={milestoneNames}
                isAddTaskShown={isAddTaskShown}
                setAddTaskIsShown={setAddTaskIsShown}
                currentMilestone={showMilestone}
              />
            </motion.div>
          )}

          {status === "filters" && (
            <motion.div
              key="filters"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 12 }}
              transition={{ duration: 0.28, ease: "easeOut" }}
            >
              <Filter
                data={projectData}
                filterMenu={filterMenu}
                setFilterMenu={setFilterMenu}
                timeFilterMenu={timeFilterMenu}
                setTimeFilterMenu={setTimeFilterMenu}
                setShowTaskFilterMenu={setShowTaskFilterMenu}
                isButtonDisable={isButtonDisable}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };

  return (
    <>
      {/* <h1 className="font-light text-[30px] mb-4 2xl:mb-6 text-theme-fg-1">Task</h1> */}
      <div className="w-full flex flex-col md:flex-row items-start justify-between gap-4 mb-7 md:mb-10">
        <header className="flex items-center bg-theme-cream-2 rounded-full p-1 w-fit space-x-1">
          {[
            { key: "task", label: "Tasks" },
            { key: "board", label: "Board" },
            { key: "filters", label: "Filters" },
          ].map(({ key, label }) => (
            <button
              key={key}
              onClick={() => setStatus(key)}
              className={`px-6 py-2 rounded-full font-title text-xs transition-colors duration-200 ${
                status === key
                  ? "bg-theme-paper text-theme-fg-1 shadow-theme-card"
                  : "text-theme-fg-3 hover:bg-theme-paper/70"
              }`}
            >
              {label}
            </button>
          ))}
        </header>

        <div className="relative flex items-center w-full justify-between md:justify-end gap-4">
          {/* LEFT SIDE BUTTONS */}
          <div className="flex items-center gap-2">
            {status !== "filters" && (
              <button
                onClick={() => setAddTaskIsShown(true)}
                className={`bg-theme-cream-2 rounded-full text-xs text-theme-fg-1 py-2 px-6 flex gap-2 items-center
          ${
            isButtonDisable
              ? "cursor-not-allowed opacity-50"
              : "hover:bg-theme-cream-3"
          }`}
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
                disabled={isButtonDisable}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 8 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.20181 1.29199V7.70866M1.16742 4.50033H7.23619"
                    stroke="#4C4C46"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="">Add Tasks</p>
              </button>
            )}

            {status === "task" && (
              <button
                className={`border-2 border-theme-cream-3 bg-theme-paper rounded-full text-xss md:text-xs text-theme-fg-1 py-2 px-4 flex gap-2 items-center
          ${isButtonDisable ? "cursor-not-allowed opacity-50" : ""}`}
                onClick={() => setShowMilestoneModal(true)}
                disabled={isButtonDisable}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 8 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.20181 1.29199V7.70866M1.16742 4.50033H7.23619"
                    stroke="#4C4C46"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p className="">Add Milestone</p>
              </button>
            )}
          </div>

          {/* RIGHT SIDE OPTIONS BUTTON */}
          <div className="relative flex items-center">
            <svg
              width="37"
              height="37"
              viewBox="0 0 37 37"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cursor-pointer z-10"
              onClick={() => setIsOption(!isOption)}
            >
              <rect width="37" height="37" rx="18.5" fill="#EFEDE5" />
              <path
                d="M13.75 19.5V19.4921M18.5 19.5V19.4921M23.25 19.5V19.4921"
                stroke="#8A8A82"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>

            {/* BACKDROP OVERLAY */}
            <div
              onClick={() => {
                setIsOption(false);
                setIsEditOpen(false);
              }}
              className={`fixed inset-0 bg-theme-ink opacity-5 z-[5] ${
                isOption ? "" : "hidden"
              }`}
            />

            {/* DROPDOWN MENU */}
            <div
              className={`absolute font-medium text-xs z-50 bg-theme-paper shadow-theme-pop rounded-theme-sm cursor-pointer w-40 right-0 top-10 transition-all duration-200 ease-out ${
                isOption
                  ? "opacity-100 translate-y-0 scale-100 pointer-events-auto"
                  : "opacity-0 -translate-y-2 scale-95 pointer-events-none"
              }`}
            >
               <button
                className={`flex gap-2 items-center justify-start border-b border-theme-cream-3 py-2 w-full pl-3 text-theme-fg-2 ${
                  isButtonDisable
                    ? "cursor-not-allowed opacity-50"
                    : "hover:bg-theme-cream-2"
                }`}
                onClick={() => {
                  setIsEditOpen(true);
                  setIsOption(false);
                }}
                disabled={isButtonDisable}
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3034 0.622289C9.80966 0.00354213 8.16594 -0.15835 6.58014 0.157084C4.99435 0.472518 3.5377 1.25111 2.39441 2.39441C1.25111 3.5377 0.472518 4.99435 0.157084 6.58014C-0.15835 8.16594 0.00354212 9.80966 0.622289 11.3034C1.24103 12.7972 2.28885 14.074 3.63322 14.9723C4.97759 15.8705 6.55814 16.35 8.175 16.35H8.475V14.4375H8.175C6.9364 14.4375 5.72561 14.0702 4.69575 13.3821C3.66588 12.694 2.8632 11.7159 2.38921 10.5716C1.91521 9.42724 1.7912 8.16806 2.03284 6.95325C2.27448 5.73845 2.87092 4.62257 3.74675 3.74675C4.62257 2.87092 5.73845 2.27448 6.95325 2.03284C8.16806 1.7912 9.42724 1.91521 10.5716 2.38921C11.7159 2.8632 12.694 3.66588 13.3821 4.69575C14.0702 5.72561 14.4375 6.9364 14.4375 8.175V8.475H16.35V8.175C16.35 6.55814 15.8705 4.97759 15.9723 4.13322C15.074 2.78885 13.7972 1.74103 12.3034 1.12229ZM11.8805 6.47531L10.5309 5.12574L6.8625 8.79417L5.16281 7.09449L3.81324 8.44406L6.8625 11.4933L11.8805 6.47531ZM16.3591 10.8226C15.5848 10.5018 14.7328 10.4179 13.9108 10.5814C13.0888 10.7449 12.3338 11.1485 11.7411 11.7411C11.1485 12.3338 10.7449 13.0888 10.5814 14.4108C11.4179 15.2328 11.5018 16.0848 11.8226 16.8591C12.1433 17.6334 12.6864 18.2952 13.3833 18.7609C14.0801 19.2265 14.8997 19.475 15.7378 18.975C16.8612 18.9737 16.9382 18.5269 17.7326 17.7326C18.5269 16.9382 18.9737 15.8609 18.975 14.7375C18.975 13.8994 18.7265 13.0801 18.2609 12.3833C17.7952 11.6864 17.1334 11.1433 16.3591 10.8226ZM13.4458 12.8043C13.8281 12.5489 14.2774 12.4126 14.7372 12.4125C15.3537 12.4132 15.9447 12.6584 16.3807 13.0943C16.8166 13.5303 17.0618 14.1213 18.0625 14.7378C18.0624 15.6976 17.9261 16.1469 17.6707 16.5292C17.4152 16.9115 17.0521 17.2095 16.6272 17.3855C16.2024 17.5615 15.7349 17.6075 15.2839 17.5178C14.8329 17.4281 14.4186 17.2067 14.0935 16.8815C13.7683 16.5564 13.5469 16.1421 13.4572 15.6911C13.3675 15.2401 13.4135 14.7726 13.5895 14.3478C13.7655 13.9229 14.0635 13.5598 14.4458 13.3043Z"
                    fill="#8A8A82"
                  />
                </svg>
                <p>Status Edit</p>
              </button>
              <button
                className={`flex gap-2 items-center justify-start border-b border-theme-cream-3 py-2 w-full pl-3 text-theme-fg-2 ${
                  isButtonDisable
                    ? "cursor-not-allowed opacity-50"
                    : "hover:bg-theme-cream-2"
                }`}
                onClick={() => {
                  setIsTrashOpen(true);
                  setIsOption(false);
                }}
              >
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1523 7.60205H1.14307"
                    stroke="#8A8A82"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.421 7.60205L14.7237 16.3267C14.6151 17.6874 14.5221 18.7427 12.0956 18.7427H6.19973C3.7732 18.7427 3.68018 17.6874 3.57164 16.3267L2.87439 7.60205"
                    stroke="#8A8A82"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12.9859 7.60228L12.513 4.78028C12.2494 3.20628 12.0866 2.05127 9.28014 2.05127H8.01646C5.21004 2.05127 5.04724 3.20628 4.78365 4.78028L4.31079 7.60228"
                    stroke="#8A8A82"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <p>Trash</p>
              </button>
            </div>
          </div>
        </div>
      </div>

      {isTrashOpen && (
        <TrashedTasks
          setOnRender={setOnRender}
          onRender={onRender}
          setIsTrashOpen={setIsTrashOpen}
          isTrashOpen={isTrashOpen}
          isButtonDisable={isButtonDisable}
        />
      )}

      {isEditOpen && (
        <TaskStatus
          setIsEditOpen={setIsEditOpen}
          setIsOption={setIsOption}
          isOption={isOption}
          setOnRender={setOnRender}
          onRender={onRender}
        />
      )}

      {isAddTaskShown && (
        <AddTask
          data={projectData}
          isAddTaskShown={isAddTaskShown}
          setAddTaskIsShown={setAddTaskIsShown}
          currentMilestone={currentMilestone}
          status={status}
          setOnRender={setOnRender}
          onRender={onRender}
        />
      )}

      {showMilestoneModal && (
        <MileStoneModal
          setModal={setShowMilestoneModal}
          setOnRender={setOnRender}
          onRender={onRender}
        />
      )}

      {switchTaskView()}
    </>
  );
};

export default Tasks;
